export default __webpack_public_path__ + "static/media/nimgenetics.5b407f91.png";